
















































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Clause extends Vue {
    @Prop(Number) private index !: number
    @Prop(Object) private clause !: Connex.Thor.Clause
    @Prop(Object) private output!: Connex.Thor.Receipt['outputs'][number]

    private tab = 0

    get events() { return this.output ? this.output.events : [] }
    get transfers(): TransferItemData[] {
        return this.output ? this.output.transfers.map(t => ({
            from: t.sender,
            to: t.recipient,
            amount: t.amount
        })) : []
    }
    get showTabs() { return this.type !== 'transfer' || this.events.length || this.transfers.length }
    get type() {
        if (this.clause.to) {
            if (this.clause.data === '0x') {
                return 'transfer'
            } else {
                return 'call'
            }
        } else {
            return 'create'
        }
    }
}
